<template>
    <v-dialog v-model="clientDownload.dialog"
            max-width="750"
            style="zIndex: 200">
        <v-card class="pa-3">
            <v-card-title class="title pa-3 text-xs-center" :class="clientDownload.sort==1?'blue-title':'pink-text'">
                <v-spacer></v-spacer>
                <template v-if="clientDownload.sort==1">
                    Download TutorClient
                </template>
                <template v-else>{{clientDownload.title}}</template>
                <div class="header-close" title="close" @click="clientDownload.dialog=false"><v-icon>close</v-icon></div>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>   
                <v-container grid-list-md class="pa-0">
                    <ul class="subheading referral-bonus pl-0 blue-title" v-if="clientDownload.sort==1">
                        <ol class="body-1 pl-0 pb-2">
                            <li class="pink-text font-weight-bold">URGENT NOTICE:<br>
                                The A-Classroom Client is scheduled to go offline on November 30th, 2020 and will be stopped using. Please download TutorClient now in case you can't take classes then.
                            </li>
                            <li>TutorClient Advantages:running smoothly,no need to switch between pages,more stable classroom.</li>
                            <li>Installation notice:You may see a security message from windows,select MORE INFO and click RUN ANYWAY,it won't damage your computer.</li>
                        </ol>
                    </ul>
                    <ul v-else class="pl-0 pink-text tutor-system-transfer" v-html="clientDownload.content">
                    </ul>
                </v-container>
            </v-card-text>
            <v-card-actions class="pt-4 pb-3">
                <v-layout class="client-download">
                    <v-flex class="text-xs-right mr-4">
                        <v-btn @click="tutorClientDownloadsLog()" class="text-none blue-button dialog-submit" 
                            ><i class="material-icons white--text">file_download</i>&nbsp;Windows Download</v-btn>
                        <div class="mt-3 mr-5">
                            <a href="https://files.acadsoc.com.cn/tutor/coursewareresources/20201107/7c611da1-47c6-42f5-a4f3-0953ebdfa30b.mp4" target="_blank">
                                <img src="../../assets/img/common/info.png" alt="">
                                <span class="font-weight-bold ml-2 blue-title">Installation Guide</span>
                            </a>
                        </div>
                    </v-flex>
                    <v-flex>
                        <v-btn @click="macTutorClientDownloadsLog()"
                            class="text-none blue-button dialog-submit mr-4" 
                        ><i class="material-icons white--text">file_download</i>&nbsp;Mac Download</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { AddTutorClientDownloadsLog } from "@/api/system"
export default {
    data:()=>({
        
    }),
    props: {
        clientDownload: {
            dialog: true,
            sort:1,
            title:'',
            content:''
        }
    },
    methods:{
        tutorClientDownloadsLog(){
            let platform = navigator.platform
            let userAgent = navigator.userAgent
            let clientInfo='platform:'+platform+',userAgent:'+userAgent
                AddTutorClientDownloadsLog(1,clientInfo,1).then(res=>{
            }) 
            window.location.href='https://cdnstatic.acadsoc.com.cn/download/tutor/TutorClient_latest.exe';
        },
        macTutorClientDownloadsLog(){
            let platform = navigator.platform
            let userAgent = navigator.userAgent
            let clientInfo='platform:'+platform+',userAgent:'+userAgent
                AddTutorClientDownloadsLog(1,clientInfo,2).then(res=>{
            }) 
            window.location.href='https://cdnstatic.acadsoc.com.cn/download/tutor/TutorClient_latest.dmg';
        }
    }
}
</script>
<style lang="scss" scoped>
.tutor-system-transfer{
    list-style:none;
}
.client-download{
    .v-btn{
        width:197px;
    }
    a{
        text-decoration:none;
        img{
            vertical-align: middle
        }
        span{
            line-height: 25px;
        }
    }
}
</style>